export default __webpack_public_path__ + "static/media/survey-card.a7d88a51.svg";